// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__46EYl","notes":"Notes_notes__3ofM5","note":"Notes_note__3Wpza","markdown":"Notes_markdown__3r_-i"};